import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Helmet } from "react-helmet";
import { Image } from "../../components/Image/Image";

const ImageConnector = ({
	wrapperClassName,
	className,
	style,
	alt,
	title,
	preload,
	image,
	src,
	width,
	height,
}) => {
	if (image) {
		return (
			<>
				{preload && (
					<Helmet>
						<link
							rel="preload"
							as="image"
							href={src}
							imageSrcSet={image.data?.srcSet}
							imageSizes={image.data?.sizes}
						/>
					</Helmet>
				)}
				<Image
					wrapperClassName={cx(wrapperClassName)}
					title={image.title || title}
					source={image.data}
					src={image.data.src ?? image.src}
					className={cx(className)}
					alt={image.alt || alt}
				/>
			</>
		);
	}

	if (src) {
		return (
			<>
				{preload && (
					<Helmet>
						<link rel="preload" as="image" href={src} />
					</Helmet>
				)}
				<img
					className={cx(className, wrapperClassName)}
					style={style}
					alt={alt}
					title={title}
					src={src}
					width={width}
					height={height}
				/>
			</>
		);
	}

	return null;
};

ImageConnector.propTypes = {
	wrapperClassName: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	alt: PropTypes.string,
	title: PropTypes.string,
	preload: PropTypes.bool,
	image: PropTypes.shape({
		src: PropTypes.string,
		alt: PropTypes.string,
		title: PropTypes.string,
		width: PropTypes.number,
		height: PropTypes.number,
		data: PropTypes.oneOfType([
			PropTypes.exact({
				aspectRatio: PropTypes.string,
				src: PropTypes.string,
				sizes: PropTypes.string,
				srcSet: PropTypes.string.isRequired,
			}),
			PropTypes.exact({
				aspectRatio: PropTypes.number,
				src: PropTypes.string,
				sources: PropTypes.arrayOf(
					PropTypes.exact({
						media: PropTypes.string,
						srcSet: PropTypes.string,
					})
				),
				sizes: PropTypes.string,
				srcSet: PropTypes.string.isRequired,
			}),
		]),
	}),
	src: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
};

ImageConnector.defaultProps = {
	wrapperClassName: undefined,
	className: undefined,
	style: undefined,
	alt: "",
	title: undefined,
	preload: false,
	image: undefined,
	src: undefined,
	width: undefined,
	height: undefined,
};

export { ImageConnector };
